module.exports = __webpack_public_path__ + "img/cover.97dcc04e.jpg";